import * as React from 'react';
import Map, { Source, Layer } from 'react-map-gl/mapbox';
import 'mapbox-gl/dist/mapbox-gl.css';
import { apiservice } from '../../service/service';
import { useRecoilState } from 'recoil';
import { tokenState } from '../../reducer/reducer/reducer/Atom';
import { Text, View } from 'react-native';

export default function MapPage({ route }) {
    const [token, setToken] = useRecoilState(tokenState);
    const [initialViewState, setInitialViewState] = React.useState(null);
    const { eventId, currentName, logId } = route.params || {};
    const [lineGeoJSON, setLineGeoJSON] = React.useState({
        type: 'Feature',
        geometry: {
            type: 'LineString',
            coordinates: [
                [-122.4, 37.8],
                [-122.41, 37.81],
                [-122.42, 37.82]
            ]
        }
    });

    const lineLayer = {
        id: 'polyline-layer',
        type: 'line',
        paint: {
            'line-color': '#ff0000',
            'line-width': 4
        }
    };

    React.useEffect(() => {
        getEventById(eventId, currentName, logId);
    }, []);

    async function getEventById(eventId, currentName, logId) {
        if (!eventId) return;

        let query = {
            profileName: currentName,
            limit: 100
        }

        const response = await apiservice({
            path: "/event/allLocationByEvent/" + eventId + "?" + new URLSearchParams(query).toString(),
            method: "get",
            token: token?.accessToken,
        });

        if (response.status == 200) {
            const locations = response.data.data.filter(item => item.id == logId)[0]?.locations
            console.log(locations);

            setInitialViewState({
                longitude: locations[0].longitude,
                latitude: locations[0].latitude,
                zoom: 20
            });

            setLineGeoJSON(value => ({
                ...value,
                geometry: {
                    ...value.geometry,
                    coordinates: locations.map(loc => [loc.longitude, loc.latitude])
                }
            }))

        }
    }

    if (!initialViewState) {
        return <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}><Text>Loading...</Text></View>;
    }

    return (
        <Map
            mapboxAccessToken="pk.eyJ1Ijoid29uZ3NhdG9ybiIsImEiOiJja2tkMDMxZnowNTAxMm9vZ21vbnE0YWNmIn0.2IjOp_X5pabJXKDN2Mw6sA"
            initialViewState={initialViewState}
            style={{ width: '100%', height: '100%' }}
            mapStyle="mapbox://styles/mapbox/streets-v9"
        >
            <Source id="polyline" type="geojson" data={lineGeoJSON}>
                <Layer {...lineLayer} />
            </Source>
        </Map>
    );
}